import React, { ReactElement, useCallback, useState } from 'react'
import styled from 'styled-components'
import Popover, { PopoverPlace } from 'react-popover'
import { useTranslation } from 'react-i18next'
import { Button, ButtonIntent } from '../../buttons/Button/Button'

type RemovePopoverProps = {
  onRemove: () => void
  text: string
  cancelText?: string
  submitText?: string
  cancelIntent?: ButtonIntent
  submitIntent?: ButtonIntent
  children: ReactElement
  position?: PopoverPlace
}

const ContentWrapper = styled.div`
  background: ${props => props.theme.color.onPrimaryLight};
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 25px;
  max-width: 300px;
`

const Text = styled.div`
  color: ${props => props.theme.color.onSurfaceMidEmphasys};
  font-size: 14px;
  margin-bottom: 15px;
`

const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 15px;
`

const PopoverBody: React.FC<{
  text: string
  cancelText?: string
  submitText?: string
  cancelIntent?: ButtonIntent
  submitIntent?: ButtonIntent
  onRemove: () => void
  onCancel: () => void
}> = ({ text, cancelText, submitText, cancelIntent = 'cancel', submitIntent = 'danger', onRemove, onCancel }) => {
  const { t } = useTranslation('ui')
  return (
    <ContentWrapper>
      <Text>{text}</Text>
      <ButtonsWrapper>
        <Button intent={cancelIntent} size={'small'} onClick={onCancel}>
          {cancelText || t('RemovePopover.cancel')}
        </Button>
        <Button intent={submitIntent} size={'small'} onClick={onRemove}>
          {submitText || t('RemovePopover.submit')}
        </Button>
      </ButtonsWrapper>
    </ContentWrapper>
  )
}

/** @deprecated use PopoverWithBtns instead */
export const RemovePopover: React.FC<RemovePopoverProps> = ({
  children,
  text,
  cancelText,
  submitText,
  cancelIntent,
  submitIntent,
  onRemove,
  position = 'start',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const togglePopover = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])
  const closePopover = useCallback(() => {
    setIsOpen(false)
  }, [])
  const handleRemove = useCallback(() => {
    setIsOpen(false)
    onRemove()
  }, [onRemove])
  return (
    <Popover
      isOpen={isOpen}
      body={
        <PopoverBody
          text={text}
          cancelText={cancelText}
          submitText={submitText}
          cancelIntent={cancelIntent}
          submitIntent={submitIntent}
          onCancel={closePopover}
          onRemove={handleRemove}
        />
      }
      onOuterAction={closePopover}
      preferPlace={position}
      tipSize={0.01}
    >
      {React.cloneElement(children, { onClick: togglePopover })}
    </Popover>
  )
}
